import {
  Box,
  Divider,
  Flex,
  FormControl,
  FormErrorMessage,
  Grid,
  GridItem,
  HStack,
  Icon,
  RadioGroup,
  Stack,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import { Field } from "formik";
import { RadioButtonField } from "../../../../../components/RadioButtonField";
import { renderTooltip } from "../../../../../components/RenderTooltip";
import { useState } from "react";
import { CustomMultiSelectWField } from "../../../../../components/MultiSelect";
import CriancaService from "../../../../../../main/services/CriancaService";
import SituacaoJuridicaService from "../../../../../../main/services/SituacaoJuridicaService";
import { IoHelpCircle } from "react-icons/io5";

export const SituacaoJuridicaAba = ({
  children,
  props,
  isMobile,
  placement,
}) => {
  const [hintProf, setHintProf] = useState(false);
  const [tipoSentenca, setTipoSentenca] = useState({
    options: [],
    isLoading: false,
  });
  const [servicosData, setServicosData] = useState({
    options: [],
    isLoading: false,
  });

  const handleGetTipoSentenca = () => {
    setTipoSentenca({ ...tipoSentenca, isLoading: true });
    CriancaService.tipoSentenca().then((res) => {
      const allOption = { id: "", descricao: "Todos" };
      setTipoSentenca({ options: [allOption, ...res.data], isLoading: false });
    });
  };

  const handleGetServicos = (tipo) => {
    setServicosData({ ...servicosData, isLoading: true });

    SituacaoJuridicaService.pesquisarSituacaoJuridica("", "ativos", tipo).then(
      (res) => {
        const allOption = { id: "", descricao: "Todos" };
        const tempOptions = res.data.map((servicos) => {
          return {
            id: servicos?.id,
            descricao: servicos.descricao,
            pessoaRestricao: servicos.pessoaRestricao,
            label: (
              <HStack justifyContent="space-between" alignItems="center">
                <Text
                  color="#1A203D"
                  fontWeight={400}
                  fontSize={{ base: "12px", md: "14px" }}
                  isTruncated
                >
                  {servicos.descricao}
                </Text>
                <Tooltip
                  label={servicos.descricao}
                  fontSize="md"
                  textAlign={"justify"}
                  placement="top"
                  hasArrow
                >
                  <span className="hint-tooltip">
                    <Icon
                      size={20}
                      aria-label="Aviso de pendente"
                      color="#6B6C71"
                      as={IoHelpCircle}
                      boxSize={{ base: "10px", md: "20px" }}
                    />
                  </span>
                </Tooltip>
              </HStack>
            ),
          };
        });
        setServicosData({
          options: [allOption, ...tempOptions],
          isLoading: false,
        });
      },
    );
  };
  return (
    <>
      <Flex mb={4} justifyContent={"space-between"}>
        <Flex gap={1}>
          <Text
            fontWeight={700}
            fontSize="16px"
            lineHeight="21.6px"
            color={"#575553"}
          >
            Situação Jurídica{" "}
          </Text>
          {renderTooltip(
            isMobile,
            placement,
            "Ao selecionar esse filtro a pesquisa será feita em ficha de adolescentes com 16 anos ou mais.",
            hintProf,
            setHintProf,
          )}
        </Flex>

        {children}
      </Flex>

      <Box>
        <Text
          fontWeight={700}
          fontSize="14px"
          lineHeight="21.6px"
          color={"#169499"}
          mt={7}
          mb={2}
        >
          Processo Judicial{" "}
        </Text>
        <Divider orientation="horizontal" borderColor={"#DDEBEA"} />
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Possui Processo Judicial?"}
          mb={4}
          mt={7}
        >
          Possui Processo Judicial?
        </Text>
        <Grid
          templateColumns="repeat(15, 1fr)"
          gap="15px"
          mt="15px"
          w="100%"
          alignItems={"center"}
        >
          <GridItem colSpan={{ base: 9, "2xl": 7 }}>
            <Field name="radioPossuiProcessoJudicial">
              {({ field, form }) => (
                <FormControl
                  isInvalid={
                    form.errors.radioPossuiProcessoJudicial &&
                    form.touched.radioPossuiProcessoJudicial
                  }
                  id="radioPossuiProcessoJudicial"
                  width="max-content"
                  zIndex={"1"}
                >
                  <RadioGroup
                    value={field.value}
                    onChange={(value) =>
                      props.setFieldValue("radioPossuiProcessoJudicial", value)
                    }
                  >
                    <Stack direction="row" gap={4}>
                      <RadioButtonField
                        id="radio-possuiProcessoJudicial-s"
                        fieldName="radioPossuiProcessoJudicial"
                        value="S"
                        label="Sim"
                      />
                      <RadioButtonField
                        id="radio-possuiProcessoJudicial-n"
                        fieldName="radioPossuiProcessoJudicial"
                        value="N"
                        label="Não"
                      />
                    </Stack>
                  </RadioGroup>
                  <FormErrorMessage mt="-1" mr="-16">
                    {form.errors.radioPossuiProcessoJudicial}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>
          </GridItem>
          <GridItem colSpan={{ base: 15 }} zIndex={"4"}>
            <CustomMultiSelectWField
              fieldName="idProcesso"
              label="Tipo de Processo"
              placeholder="Selecione o Tipo"
              getOptionLabel={(option) => option?.label || option.descricao}
              getOptionValue={(option) => option.id}
              isLoading={servicosData.isLoading}
              options={servicosData.options}
              onChange={(value) => {
                props.setFieldValue("idProcesso", value);
              }}
              values={props?.values?.idProcesso[0] || ""}
              onFocus={() => handleGetServicos("P")}
              visible
              todos
            />
          </GridItem>
        </Grid>
      </Box>
      <Box>
        <Text
          fontWeight={700}
          fontSize="14px"
          lineHeight="21.6px"
          color={"#169499"}
          mt={7}
          mb={2}
        >
          Procedimento Judicial{" "}
        </Text>
        <Divider orientation="horizontal" borderColor={"#DDEBEA"} />
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Possui Procedimento Judicial?"}
          mb={4}
          mt={7}
        >
          Possui Procedimento Judicial?
        </Text>
        <Grid
          templateColumns="repeat(15, 1fr)"
          gap="15px"
          mt="15px"
          w="100%"
          alignItems={"center"}
        >
          <GridItem colSpan={{ base: 9, "2xl": 7 }}>
            <Field name="radioPossuiProcedimentoJudicial">
              {({ field, form }) => (
                <FormControl
                  isInvalid={
                    form.errors.radioPossuiProcedimentoJudicial &&
                    form.touched.radioPossuiProcedimentoJudicial
                  }
                  id="radioPossuiProcedimentoJudicial"
                  width="max-content"
                  zIndex={"1"}
                >
                  <RadioGroup
                    value={field.value}
                    onChange={(value) =>
                      props.setFieldValue(
                        "radioPossuiProcedimentoJudicial",
                        value,
                      )
                    }
                  >
                    <Stack direction="row" gap={4}>
                      <RadioButtonField
                        id="radio-possuiProcedimentoJudicial-s"
                        fieldName="radioPossuiProcedimentoJudicial"
                        value="S"
                        label="Sim"
                      />
                      <RadioButtonField
                        id="radio-possuiProcedimentoJudicial-n"
                        fieldName="radioPossuiProcedimentoJudicial"
                        value="N"
                        label="Não"
                      />
                    </Stack>
                  </RadioGroup>
                  <FormErrorMessage mt="-1" mr="-16">
                    {form.errors.radioPossuiProcedimentoJudicial}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>
          </GridItem>
          <GridItem colSpan={{ base: 15 }} zIndex={"3"}>
            <CustomMultiSelectWField
              fieldName="idProcedimento"
              label={`Tipo de Procedimento${props?.values?.radioPossuiProcedimentoJudicial === "S" || props?.values?.radioPossuiProcedimentoJudicial === "N" ? "*" : ""}`}
              placeholder="Selecione o Tipo"
              getOptionLabel={(option) => option?.label || option.descricao}
              getOptionValue={(option) => option.id}
              isLoading={servicosData.isLoading}
              options={servicosData.options}
              onChange={(value) => {
                props.setFieldValue("idProcedimento", value);
              }}
              values={props?.values?.idProcedimento[0] || ""}
              onFocus={() => handleGetServicos("D")}
              visible
              todos
            />
          </GridItem>
        </Grid>
      </Box>
      <Box>
        <Text
          fontWeight={700}
          fontSize="14px"
          lineHeight="21.6px"
          color={"#169499"}
          mt={7}
          mb={2}
        >
          Decisão Liminar{" "}
        </Text>
        <Divider orientation="horizontal" borderColor={"#DDEBEA"} />
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Há Decisão Liminar de Colocação em Família Substituta?"}
          mb={4}
          mt={7}
        >
          Há Decisão Liminar de Colocação em Família Substituta?
        </Text>
        <Grid
          templateColumns="repeat(15, 1fr)"
          gap="15px"
          mt="15px"
          w="100%"
          alignItems={"center"}
        >
          <GridItem colSpan={{ base: 9, "2xl": 7 }}>
            <Field name="radioDecisaoLiminar">
              {({ field, form }) => (
                <FormControl
                  isInvalid={
                    form.errors.radioDecisaoLiminar &&
                    form.touched.radioDecisaoLiminar
                  }
                  id="radioDecisaoLiminar"
                  width="max-content"
                  zIndex={"1"}
                >
                  <RadioGroup
                    value={field.value}
                    onChange={(value) =>
                      props.setFieldValue("radioDecisaoLiminar", value)
                    }
                  >
                    <Stack direction="row" gap={4}>
                      <RadioButtonField
                        id="radio-decisaoLiminar-s"
                        fieldName="radioDecisaoLiminar"
                        value="S"
                        label="Sim"
                      />
                      <RadioButtonField
                        id="radio-decisaoLiminar-n"
                        fieldName="radioDecisaoLiminar"
                        value="N"
                        label="Não"
                      />
                    </Stack>
                  </RadioGroup>
                  <FormErrorMessage mt="-1" mr="-16">
                    {form.errors.radioDecisaoLiminar}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>
          </GridItem>
        </Grid>
      </Box>
      <Box>
        <Text
          fontWeight={700}
          fontSize="14px"
          lineHeight="21.6px"
          color={"#169499"}
          mt={7}
          mb={2}
        >
          Sentença{" "}
        </Text>
        <Divider orientation="horizontal" borderColor={"#DDEBEA"} />
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Sentença?"}
          mb={4}
          mt={7}
        >
          Sentença?
        </Text>
        <Grid
          templateColumns="repeat(15, 1fr)"
          gap="15px"
          mt="15px"
          w="100%"
          alignItems={"center"}
        >
          <GridItem colSpan={{ base: 9, "2xl": 7 }}>
            <Field name="radioSentenca">
              {({ field, form }) => (
                <FormControl
                  isInvalid={
                    form.errors.radioSentenca && form.touched.radioSentenca
                  }
                  id="radioSentenca"
                  width="max-content"
                  zIndex={"1"}
                >
                  <RadioGroup
                    value={field.value}
                    onChange={(value) =>
                      props.setFieldValue("radioSentenca", value)
                    }
                  >
                    <Stack direction="row" gap={4}>
                      <RadioButtonField
                        id="radio-sentenca-s"
                        fieldName="radioSentenca"
                        value="S"
                        label="Sim"
                      />
                      <RadioButtonField
                        id="radio-sentenca-n"
                        fieldName="radioSentenca"
                        value="N"
                        label="Não"
                      />
                    </Stack>
                  </RadioGroup>
                  <FormErrorMessage mt="-1" mr="-16">
                    {form.errors.radioSentenca}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>
          </GridItem>
          <GridItem colSpan={{ base: 15 }} zIndex={"2"}>
            <CustomMultiSelectWField
              fieldName="idTipoSentenca"
              label="Tipo de Sentença"
              placeholder="Selecione o Tipo"
              getOptionLabel={(option) => option?.descricao}
              getOptionValue={(option) => option.id}
              isLoading={tipoSentenca.isLoading}
              options={tipoSentenca.options}
              onChange={(value) => {
                props.setFieldValue("idTipoSentenca", value);
              }}
              values={props?.values?.idTipoSentenca[0] || ""}
              onFocus={() => handleGetTipoSentenca()}
              visible
              todos
            />
          </GridItem>
        </Grid>
      </Box>

      <Box>
        <Text
          fontWeight={700}
          fontSize="14px"
          lineHeight="21.6px"
          color={"#169499"}
          mt={7}
          mb={2}
        >
          Recurso{" "}
        </Text>
        <Divider orientation="horizontal" borderColor={"#DDEBEA"} />
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Recurso?"}
          mb={4}
          mt={7}
        >
          Recurso?
        </Text>
        <Grid
          templateColumns="repeat(15, 1fr)"
          gap="15px"
          mt="15px"
          w="100%"
          alignItems={"center"}
        >
          <GridItem colSpan={{ base: 9, "2xl": 7 }}>
            <Field name="radioRecurso">
              {({ field, form }) => (
                <FormControl
                  isInvalid={
                    form.errors.radioRecurso && form.touched.radioRecurso
                  }
                  id="radioRecurso"
                  width="max-content"
                  zIndex={"1"}
                >
                  <RadioGroup
                    value={field.value}
                    onChange={(value) =>
                      props.setFieldValue("radioRecurso", value)
                    }
                  >
                    <Stack direction="row" gap={4}>
                      <RadioButtonField
                        id="radio-recurso-s"
                        fieldName="radioRecurso"
                        value="S"
                        label="Sim"
                      />
                      <RadioButtonField
                        id="radio-recurso-n"
                        fieldName="radioRecurso"
                        value="N"
                        label="Não"
                      />

                      <RadioButtonField
                        id="radio-recurso-si"
                        fieldName="radioRecurso"
                        value="I"
                        label="Sem Informação"
                      />
                    </Stack>
                  </RadioGroup>
                  <FormErrorMessage mt="-1" mr="-16">
                    {form.errors.radioRecurso}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>
          </GridItem>
        </Grid>
      </Box>
      <Box>
        <Text
          fontWeight={700}
          fontSize="14px"
          lineHeight="21.6px"
          color={"#169499"}
          mt={7}
          mb={2}
        >
          Trânsito em Julgado{" "}
        </Text>
        <Divider orientation="horizontal" borderColor={"#DDEBEA"} />
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Trânsito em Julgado?"}
          mb={4}
          mt={7}
        >
          Trânsito em Julgado?
        </Text>
        <Grid
          templateColumns="repeat(15, 1fr)"
          gap="15px"
          mt="15px"
          w="100%"
          alignItems={"center"}
        >
          <GridItem colSpan={{ base: 9, "2xl": 7 }}>
            <Field name="radioTransitoJulgado">
              {({ field, form }) => (
                <FormControl
                  isInvalid={
                    form.errors.radioTransitoJulgado &&
                    form.touched.radioTransitoJulgado
                  }
                  id="radioTransitoJulgado"
                  width="max-content"
                  zIndex={"1"}
                >
                  <RadioGroup
                    value={field.value}
                    onChange={(value) =>
                      props.setFieldValue("radioTransitoJulgado", value)
                    }
                  >
                    <Stack direction="row" gap={4}>
                      <RadioButtonField
                        id="radio-transitoJulgado-s"
                        fieldName="radioTransitoJulgado"
                        value="S"
                        label="Sim"
                      />
                      <RadioButtonField
                        id="radio-transitoJulgado-n"
                        fieldName="radioTransitoJulgado"
                        value="N"
                        label="Não"
                      />
                    </Stack>
                  </RadioGroup>
                  <FormErrorMessage mt="-1" mr="-16">
                    {form.errors.radioTransitoJulgado}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>
          </GridItem>
        </Grid>
      </Box>
    </>
  );
};
